function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rating-12a_svg__a",
  d: "M0 0h80v79.999H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rating-12a_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rating-12a_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40 78.597C18.683 78.597 1.402 61.317 1.402 40 1.403 18.684 18.684 1.404 40 1.404S78.597 18.684 78.597 40c0 21.317-17.28 38.597-38.597 38.597M40 0C17.91 0 0 17.909 0 40c0 22.092 17.908 39.999 40 39.999 22.091 0 40-17.907 40-40C80 17.91 62.09 0 40 0",
  fill: "#000",
  mask: "url(#rating-12a_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 75.088c-19.379 0-35.088-15.708-35.088-35.087C4.912 20.623 20.622 4.913 40 4.913c19.38 0 35.088 15.71 35.088 35.088 0 19.379-15.709 35.087-35.088 35.087m0-73.684C18.684 1.403 1.403 18.683 1.403 40S18.684 78.596 40 78.596c21.316 0 38.597-17.28 38.597-38.596 0-21.316-17.28-38.597-38.597-38.597",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 4.912C20.62 4.912 4.911 20.622 4.911 40c0 19.38 15.71 35.088 35.087 35.088 19.38 0 35.088-15.709 35.088-35.088C75.087 20.622 59.378 4.912 40 4.912",
  fill: "#FF7D13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.15 25.522v28.077h-5.115V37.543c0-2.663 0-3.453-2.29-3.453H8.172v-3.203h.54c2.622-.041 6.158-.083 7.28-5.365h4.159zm23.702 23.751V53.6H24.76v-4.035c3.577-2.454 7.113-5.823 8.777-7.528 1.539-1.58 4.117-4.285 4.117-7.988 0-2.163-1.08-4.2-3.701-4.2-4.12 0-3.994 4.492-3.952 6.488l-5.241-.457c0-3.952 1.29-6.489 2.37-7.779 1.539-1.788 4.2-3.036 7.239-3.036 5.323 0 9.026 3.452 9.026 8.777 0 4.534-2.787 7.778-5.864 10.565-.625.541-4.368 3.702-5.95 4.867h12.27zm19.404-1.141H52.76L51.135 53.6h-5.584l9.427-27.966h5.941L70.466 53.6H64.88l-1.624-5.467zm-1.387-4.555l-3.84-12.874-3.882 12.874h7.722z",
  fill: "#FFF"
}));

function SvgRating12A(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
}

export default SvgRating12A;